import PropTypes from "prop-types";
import { Loader } from "components/Loader";
import { formatCurrency } from "utils";
import { formatShortDate } from "./billingState";
import { HistoryTableWrapper, StatusPill } from "./BillingPanel.styles";

const statusTone = (status) => {
  if (status === "paid") return "paid";
  if (status === "uncollectible") return "failed";
  return "neutral";
};

const statusLabel = (status) =>
  status ? status.charAt(0).toUpperCase() + status.slice(1) : "";

export const BillingHistoryTable = ({
  rows,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
  onViewInvoice,
}) => {
  if (isLoading) {
    return (
      <HistoryTableWrapper>
        <div className="history-empty">
          <Loader />
        </div>
      </HistoryTableWrapper>
    );
  }

  return (
    <HistoryTableWrapper>
      <table>
        <thead>
          <tr>
            <th className="col-date">Date</th>
            <th className="col-amount">Amount</th>
            <th className="col-status">Status</th>
            <th className="col-invoice">Invoice</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            const date = formatShortDate(row.created);
            return (
              <tr key={row.id || index}>
                <td>{date}</td>
                <td>{formatCurrency((row.total || 0) / 100)}</td>
                <td>
                  <StatusPill $tone={statusTone(row.status)}>
                    {statusLabel(row.status)}
                  </StatusPill>
                </td>
                <td className="col-invoice">
                  <button
                    type="button"
                    className="view-link"
                    aria-label={`View invoice from ${date}`}
                    onClick={() => onViewInvoice(row.hosted_invoice_url)}
                  >
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length === 0 && (
        <div className="history-empty">No transaction history</div>
      )}
      {hasNextPage && (
        <button
          type="button"
          className="history-more"
          disabled={isFetchingNextPage}
          onClick={onLoadMore}
        >
          {isFetchingNextPage ? "Loading..." : "Show more"}
        </button>
      )}
    </HistoryTableWrapper>
  );
};

BillingHistoryTable.propTypes = {
  rows: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  hasNextPage: PropTypes.bool,
  isFetchingNextPage: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  onViewInvoice: PropTypes.func.isRequired,
};
